import script from "./Security.vue?vue&type=script&setup=true&lang=js"
export * from "./Security.vue?vue&type=script&setup=true&lang=js"

import "./Security.vue?vue&type=style&index=0&id=4572bf6c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4572bf6c"]])

export default __exports__